import React from "react";
import { UiAccordion } from "../../../components/common/UiAccordion";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";

export const GoalsFaq = () => {

    const Faqs = [
        {
            id: 1,
            title: 'About this goal',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 2,
            title: 'How long is it available for?',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 3,
            title: 'Duis enim bibendum dui ut fringilla suspendisse vel sed ',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 4,
            title: 'Lectus fringilla volutpat egestas nisi, viverra mauris',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 5,
            title: 'Vitae sollicitudin vitae libero tincidunt',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        },
        {
            id: 6,
            title: 'Tellus velit vitae arcu lacinia pharetra, ut lectus pulvinar facilisis',
            description: 'Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.'
        }
    ]



    return (
        <>
            <div className="sb-goals-faq-wrapper">
                <UiContentCol>
                    <UiCardTitle title="Goal FAQ’s" />
                    <UiAccordion items={Faqs} />
                </UiContentCol>
            </div>
        </>
    )
}